import React, { useEffect } from 'react';
import { useScene } from '../../context/SceneContext';

/**
 * SceneClickRegenerate — captures clicks on the document body and triggers
 * `mutate()` unless the user clicked an interactive element (link, button,
 * input, anything with role=button or data-no-mutate).
 *
 * This makes the entire interface feel like a 'generated picture' that
 * regenerates on click — exactly the Paris-Travel reference behaviour —
 * without breaking ordinary navigation.
 */
const INTERACTIVE_SELECTOR =
  'a, button, input, textarea, select, label, [role="button"], [data-no-mutate], iframe';

export default function SceneClickRegenerate() {
  const { mutate } = useScene();

  useEffect(() => {
    const handler = (e) => {
      if (e.target.closest(INTERACTIVE_SELECTOR)) return;
      mutate();
    };
    window.addEventListener('click', handler, { passive: true });
    return () => window.removeEventListener('click', handler);
  }, [mutate]);

  return null;
}
